import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UIAnalyticsEvent from './UIAnalyticsEvent'; // This component is used to grab the analytics functions off context.
// It uses legacy context, but provides an API similar to 16.3 context.
// This makes it easier to use with the forward ref API.

var AnalyticsContextConsumer =
/*#__PURE__*/
function (_Component) {
  _inherits(AnalyticsContextConsumer, _Component); // Store references to the original and patched event props so we can determine when to update
  // the patched props


  function AnalyticsContextConsumer(_props) {
    var _this;

    _classCallCheck(this, AnalyticsContextConsumer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnalyticsContextConsumer).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "originalEventProps", {});

    _defineProperty(_assertThisInitialized(_this), "patchedEventProps", {});

    _defineProperty(_assertThisInitialized(_this), "updatePatchedEventProps", function (props) {
      var changedPropCallbacks = Object.keys(_this.props.createEventMap).filter(function (p) {
        return _this.originalEventProps[p] !== props[p];
      });

      if (changedPropCallbacks.length > 0) {
        _this.patchedEventProps = _objectSpread({}, _this.patchedEventProps, _this.mapCreateEventsToProps(changedPropCallbacks, props));
        changedPropCallbacks.forEach(function (p) {
          _this.originalEventProps[p] = props[p];
        });
      }

      return _this.patchedEventProps;
    });

    _defineProperty(_assertThisInitialized(_this), "mapCreateEventsToProps", function (changedPropNames, props) {
      return changedPropNames.reduce(function (modified, propCallbackName) {
        var eventCreator = _this.props.createEventMap[propCallbackName];
        var providedCallback = props[propCallbackName];

        if (!['object', 'function'].includes(_typeof(eventCreator))) {
          return modified;
        }

        var modifiedCallback = function modifiedCallback() {
          var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(_this.createAnalyticsEvent, props) : _this.createAnalyticsEvent(eventCreator);

          if (providedCallback) {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            providedCallback.apply(void 0, args.concat([analyticsEvent]));
          }
        };

        return _objectSpread({}, modified, _defineProperty({}, propCallbackName, modifiedCallback));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "createAnalyticsEvent", function (payload) {
      var _this$context = _this.context,
          getAtlaskitAnalyticsEventHandlers = _this$context.getAtlaskitAnalyticsEventHandlers,
          getAtlaskitAnalyticsContext = _this$context.getAtlaskitAnalyticsContext;
      var context = typeof getAtlaskitAnalyticsContext === 'function' && getAtlaskitAnalyticsContext() || [];
      var handlers = typeof getAtlaskitAnalyticsEventHandlers === 'function' && getAtlaskitAnalyticsEventHandlers() || [];
      return new UIAnalyticsEvent({
        context: context,
        handlers: handlers,
        payload: payload
      });
    });

    Object.keys(_this.props.createEventMap).forEach(function (p) {
      _this.originalEventProps[p] = _props.wrappedComponentProps[p];
    });
    _this.patchedEventProps = _this.mapCreateEventsToProps(Object.keys(_this.props.createEventMap), _props.wrappedComponentProps);
    return _this;
  } // Update patched event props only if the original props have changed


  _createClass(AnalyticsContextConsumer, [{
    key: "render",
    value: function render() {
      var patchedEventProps = this.updatePatchedEventProps(this.props.wrappedComponentProps);
      return this.props.children({
        createAnalyticsEvent: this.createAnalyticsEvent,
        patchedEventProps: patchedEventProps
      });
    }
  }]);

  return AnalyticsContextConsumer;
}(Component);

_defineProperty(AnalyticsContextConsumer, "contextTypes", {
  getAtlaskitAnalyticsEventHandlers: PropTypes.func,
  getAtlaskitAnalyticsContext: PropTypes.func
});

_defineProperty(AnalyticsContextConsumer, "defaultProps", {
  createEventMap: {}
});

export default function withAnalyticsEvents() {
  var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    // $FlowFixMe - flow 0.67 doesn't know about forwardRef
    var WithAnalyticsEvents = React.forwardRef(function (props, ref) {
      return React.createElement(AnalyticsContextConsumer, {
        createEventMap: createEventMap,
        wrappedComponentProps: props
      }, function (_ref) {
        var createAnalyticsEvent = _ref.createAnalyticsEvent,
            patchedEventProps = _ref.patchedEventProps;
        return React.createElement(WrappedComponent, _extends({}, props, patchedEventProps, {
          createAnalyticsEvent: createAnalyticsEvent,
          ref: ref
        }));
      });
    });
    WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return WithAnalyticsEvents;
  };
}
export var withAnalyticsForSumTypeProps = withAnalyticsEvents;